import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import ChecklistProgress from "../../components/automap/buyerChecklist/ChecklistProgress";
import { trackBuyerChecklistEvent } from "../../constants/buyerChecklistConstants";
import { getAllChecklistItemIds } from "../../data/buyerChecklistContent";
import { useBuyerChecklistProgress } from "../../hooks/useBuyerChecklistProgress";
import { calculateChecklistProgress, listSavedChecklistKeys, loadChecklistState } from "../../utils/buyerChecklistStorage";
import "../../styles/buyerChecklist.css";

export default function MyChecklistPage() {
  const generalIds = useMemo(() => getAllChecklistItemIds(), []);
  const general = useBuyerChecklistProgress(null, generalIds);

  useEffect(() => {
    trackBuyerChecklistEvent("buyer_checklist_page_viewed", { page: "my_checklist" });
    document.title = "Mi checklist | AutoMapa";
  }, []);

  const savedListingKeys = useMemo(
    () => listSavedChecklistKeys().filter((key) => key.startsWith("automap_checklist_listing_")),
    []
  );

  return (
    <div className="buyer-checklist-page">
      <header className="buyer-checklist-page__hero">
        <div className="wrap">
          <h1>Mi checklist</h1>
          <p>Tu progreso se guarda en este navegador. No necesitas crear una cuenta.</p>
        </div>
      </header>
      <main className="buyer-checklist-page__main">
        <section className="buyer-checklist-section" style={{ padding: "1rem" }}>
          <h2>Checklist general</h2>
          <ChecklistProgress progress={general.progress} />
          <div className="buyer-checklist-guide__cta-row">
            <Link to="/checklist-compra" className="buyer-checklist-btn buyer-checklist-btn--primary">
              Continuar checklist
            </Link>
            <button type="button" className="buyer-checklist-btn buyer-checklist-btn--soft" onClick={general.resetProgress}>
              Reiniciar progreso
            </button>
          </div>
        </section>

        {savedListingKeys.length ? (
          <section className="buyer-checklist-guide__section">
            <h2>Checklists por vehículo</h2>
            <ul>
              {savedListingKeys.map((key) => {
                const listingId = key.replace("automap_checklist_listing_", "");
                const state = loadChecklistState(listingId);
                const progress = calculateChecklistProgress(generalIds, state.checked);
                return (
                  <li key={key} style={{ marginBottom: "0.75rem" }}>
                    <Link to={`/checklist-compra?listingId=${encodeURIComponent(listingId)}`}>
                      Vehículo {listingId}
                    </Link>
                    {" — "}
                    {progress.percent}% completado
                  </li>
                );
              })}
            </ul>
          </section>
        ) : (
          <p className="muted">Aún no tienes checklists guardadas por vehículo.</p>
        )}
      </main>
    </div>
  );
}
